
import { ContentsCollection, ContentsDocument } from '@platyplus/rxdb-hasura'
import { toObserver, useSubscription } from '@vueuse/rxjs'
import { computed, defineComponent, PropType, ref, toRef } from 'vue'

import { useNewDocumentFactory } from '../../../composables'

export default defineComponent({
  name: 'CollectionTable',
  props: {
    collection: {
      type: Object as PropType<ContentsCollection>,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const collection = toRef(props, 'collection')
    const { newDoc } = useNewDocumentFactory(collection)
    const properties = computed(() => collection.value.properties)
    // TODO not sure it's optimised
    const documents = ref<ContentsDocument[]>([])
    useSubscription(
      props.collection.find().sort('label').$.subscribe(toObserver(documents))
    )

    // TODO canEditCollection
    return { properties, newDoc, documents }
  }
})
